module.exports = __webpack_public_path__ + "static/media/1_registrieren_frei.8f9a05bc.png";